import { z } from 'zod'
import { toUidFromSchema } from 'src/util/src/uid'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { SocialChannelTypeSchema, SocialChannelTypeUidSchema } from './SocialChannelType'
import { NotesSchema } from '../../Generic/models/Notes'
import { OriginalIdSchema } from '../../Generic/models/OriginalId'
import { OriginalSlugSchema } from '../../Generic/models/OriginalSlug'

export const SocialChannelSchema = z.object({
  oid: OriginalIdSchema.optional(),
  slug: OriginalSlugSchema,
  type: SocialChannelTypeSchema,
  notes: NotesSchema,
})

export const SocialChannelsSchema = z.array(SocialChannelSchema)
  .superRefine(getDuplicatesRefinement('SocialChannel', getSocialChannelUid))

export const SocialChannelUidSchema = z.object({
  slug: SocialChannelSchema.shape.slug,
  type: SocialChannelTypeUidSchema,
})

export type SocialChannel = z.infer<typeof SocialChannelSchema>

export type SocialChannelUid = z.infer<typeof SocialChannelUidSchema>

export function validateSocialChannel(channel: SocialChannel): SocialChannel {
  return SocialChannelSchema.parse(channel)
}

export function validateSocialChannels(channels: SocialChannel[]): SocialChannel[] {
  return SocialChannelsSchema.parse(channels)
}

export function getSocialChannelUid(channelUid: SocialChannelUid) {
  return toUidFromSchema(channelUid, SocialChannelUidSchema)
}
